// @ngInject
const config = ($stateProvider) => {
  $stateProvider.state('configuration.articleTags', {
    url: '/articletags',
    templateUrl: 'main/configuration/articleTags/articleTags.tpl.html',
    data: { pageTitle: 'Article tags' },
  });
};

angular.module('configuration.articleTags', []).config(config);
